module.exports = __webpack_public_path__ + "img/6.70b1295e.png";